<template>
  <footer class="kb-footer">
    <div class="container-xl">
      <div class="kb-footer__grid">

        <!-- Brand Column -->
        <div class="kb-footer__brand">
          <div class="kb-footer__logo">
            <img src="@/assets/logo.webp" alt="KeBee Industries" loading="lazy" />
            <!-- <span>KeBee <span>Industries</span></span> -->
          </div>
          <p>India's trusted manufacturer of heavy-duty tarpaulins, agro nets, and protective plastic solutions since our founding in Mumbai.</p>
          <div class="kb-footer__social">
            <a href="https://wa.me/919892310123" target="_blank" aria-label="WhatsApp"><i class="bi bi-whatsapp"></i></a>
            <a href="mailto:info@kebeeindustries.com" aria-label="Email"><i class="bi bi-envelope-fill"></i></a>
            <a href="Tel:+919892310123" aria-label="Phone"><i class="bi bi-telephone-fill"></i></a>
          </div>
        </div>

        <!-- Products Column -->
        <div class="kb-footer__col">
          <h4>Products</h4>
          <ul>
            <li><router-link to="/products/hdpe-tarpaulins">HDPE Tarpaulins</router-link></li>
            <li><router-link to="/products/pvc-fr-tarpaulins">PVC-FR Tarpaulins</router-link></li>
            <li><router-link to="/products/canvas-tarpaulin">Canvas Tarpaulin</router-link></li>
            <li><router-link to="/products/agro-shade-nets">Agro Shade Nets</router-link></li>
            <li><router-link to="/products/barsati-plastic">Barsati Plastic</router-link></li>
            <li><router-link to="/products/nylon-ropes">Nylon Ropes</router-link></li>
          </ul>
        </div>

        <!-- Company Column -->
        <div class="kb-footer__col">
          <h4>Company</h4>
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/products">All Products</router-link></li>
            <li><router-link to="/blog">Blog</router-link></li>
          </ul>
        </div>

        <!-- Contact Column -->
        <div class="kb-footer__col">
          <h4>Contact</h4>
          <ul class="kb-footer__contact">
            <li>
              <i class="bi bi-geo-alt-fill"></i>
              <span>Kala Darshan, 5, MG Crossword No. 3, opp. Achija Hotel, nr. Saraswat Bank, Kandivali West, Mumbai, Maharashtra 400067</span>
            </li>
            <li>
              <i class="bi bi-telephone-fill"></i>
              <a href="Tel:+919892310123">+91 98923 10123</a>
            </li>
            <li>
              <i class="bi bi-envelope-fill"></i>
              <a href="mailto:info@kebeeindustries.com">info@kebeeindustries.com</a>
            </li>
          </ul>
        </div>

      </div>

      <div class="kb-footer__bottom">
        <p>© 2026 <strong>KeBee Industries</strong>. All Rights Reserved.</p>
        <p>Made with <i class="bi bi-heart-fill text-danger"></i> in Mumbai, India</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>

<style scoped>
.kb-footer {
  background: #0F1F3D;
  color: rgba(255,255,255,0.75);
  padding: 60px 0 0;
  font-family: 'Inter', sans-serif;
}

.kb-footer__grid {
  display: grid;
  grid-template-columns: 1.8fr 1fr 1fr 1.5fr;
  gap: 3rem;
  padding-bottom: 48px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

/* Brand */
.kb-footer__brand {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.kb-footer__logo {
  display: flex;
  align-items: center;
  gap: 10px;
}
.kb-footer__logo img {
  height: 56px;
  background: #fff;
  padding: 10px 10px;
  border-radius: 12px;
}
.kb-footer__logo span {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.15rem;
  color: #fff;
}
.kb-footer__logo span span {
  color: #F59E0B;
}
.kb-footer__brand p {
  font-size: 0.9rem;
  line-height: 1.7;
  color: rgba(255,255,255,0.6);
}
.kb-footer__social {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}
.kb-footer__social a {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.7);
  font-size: 1rem;
  text-decoration: none;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}
.kb-footer__social a:hover {
  background: #F59E0B;
  border-color: #F59E0B;
  color: #fff;
}

/* Columns */
.kb-footer__col h4 {
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #F59E0B;
  margin-bottom: 1.2rem;
}
.kb-footer__col ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.kb-footer__col a {
  color: rgba(255,255,255,0.65);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}
.kb-footer__col a:hover {
  color: #F59E0B;
}

/* Contact list */
.kb-footer__contact li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.88rem;
  line-height: 1.6;
}
.kb-footer__contact i {
  color: #F59E0B;
  margin-top: 3px;
  flex-shrink: 0;
}
.kb-footer__contact span,
.kb-footer__contact a {
  color: rgba(255,255,255,0.65);
  text-decoration: none;
}
.kb-footer__contact a:hover {
  color: #F59E0B;
}

/* Bottom bar */
.kb-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  font-size: 0.85rem;
  color: rgba(255,255,255,0.4);
  flex-wrap: wrap;
  gap: 10px;
}
.kb-footer__bottom strong {
  color: rgba(255,255,255,0.7);
}

@media (max-width: 992px) {
  .kb-footer__grid {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}
@media (max-width: 576px) {
  .kb-footer__grid {
    grid-template-columns: 1fr;
  }
  .kb-footer__bottom {
    flex-direction: column;
    text-align: center;
  }
}
</style>
